/**
 * Shared filename allowlist for all portal upload paths (portal file uploads,
 * 2-way messaging, and order request uploads). Only letters, numbers, spaces,
 * hyphens, underscores, and a single dot before the extension are permitted.
 * Applied consistently so the effective policy is the strictest one across all
 * three ingress points.
 */
export const VALID_FILENAME_PATTERN = /^[A-Za-z0-9_\- ]+(\.[A-Za-z0-9_\- ]+)*$/

